/* eslint-disable */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-return-assign */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import throttle from 'ggApp/utils/throttle';
import { Portal } from 'react-portal';
import debounce from 'ggApp/utils/debounce';
import { withDeviceInfo } from 'ggApp/shared/components/viewport';
import memoize from 'fast-memoize';
import GestureManager from './GestureManager';
import CloseIcon from './CancelIcon';
import {
    Background,
    CloseButton,
    ImageGallery,
    Root,
    SlideImage,
    Slider,
    SliderWrap,
    ThumbImg,
    ThumbList,
    ThumbWrap,
} from './styled';

const MARGINS = {
    desktop: {
        top: 133,
        bottom: 40,
        horizontal: (x) => 0.05 * x,
    },
    mobile: {
        top: 60,
        horizontal: 40,
        bottom: 64,
    },
};

const getInnerBoxSize = (
    boxInAR,
    containerAR,
    { width: containerWidth, height: containerHeight } = {},
) => ({
    width: boxInAR <= containerAR ? containerHeight * boxInAR : containerWidth,
    height: boxInAR <= containerAR ? containerHeight : containerWidth / boxInAR,
});

@withDeviceInfo
export default class ZoomedGallery extends Component {
    slides = [];

    thumbnails = [];

    galleryRootPosition = {};

    sliderPosition = [];

    slidesPosition = [];

    sliderZoomedPosition = [];

    slidesZoomedPosition = [];

    // eslint-disable-next-line react/state-in-constructor
    state = {
        isReady: false,
        isOpen: false,
        index: 0,
        isPositionSet: false,
    };

    setNewIndex = memoize((newIndex) => () => {
        const { index } = this.state;
        if (newIndex !== index) {
            this.setState({ index: newIndex });
            this.GestureManager && this.GestureManager.setNewIndex(newIndex);
        }
    });

    constructor(props) {
        super(props);
        this.debouncedGetPosition = debounce(this.getPosition, 100);
        this.throttledSyncParentSlider = throttle(
            this.setActiveIndexOnScroll,
            500,
        );
    }

    componentDidMount() {
        this.setState({
            isReady: true,
        });
        window.addEventListener('resize', this.debouncedGetPosition, {
            passive: true,
        });
        window.addEventListener('scroll', this.debouncedGetPosition, {
            passive: true,
        });
    }

    componentWillReceiveProps(nextProps) {
        const { isPositionSet, isOpen, index } = this.state;
        const { index: propsIndex } = this.props;
        const {
            rootRef: nextGalleryRef,
            parentSliderRef,
            index: nextPropsIndex,
            isOpen: propsNextIsOpen,
            slidesAspectRatio,
            userDevice: nextUserDevice,
        } = nextProps;
        const nextIndex = index !== nextPropsIndex ? nextPropsIndex : propsIndex;
        // First getPosition trigger
        if (index !== nextIndex) {
            this.setState({ index: nextIndex });
        }
        if (
            !isPositionSet
            && nextGalleryRef
            && parentSliderRef
            && slidesAspectRatio.length !== 0
        ) {
            this.getPosition(null, nextProps);
        }
        if (!isOpen && propsNextIsOpen) {
            this.onOpen();
        }

        if (this.isMobile(nextUserDevice) && !this.GestureManager) {
            this.GestureManager = new GestureManager();
            this.GestureManager.init();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.debouncedGetPosition, {
            passive: true,
        });
        window.removeEventListener('scroll', this.debouncedGetPosition, {
            passive: true,
        });
    }

    onOpen = () => {
        this.setState({ isOpen: true });
        window.removeEventListener('scroll', this.debouncedGetPosition, {
            passive: true,
        });
        window.addEventListener('keydown', this.onKeyPress);
        if (this.isMobile()) {
            this.GestureManager.startListening({
                refs: { slider: this.slider, slides: this.slides, thumbnails: this.thumbnails },
                index: this.props.index,
                onClose: this.onClose,
            });
        }
    };

    onKeyPress = (e) => {
        if (e.key === 'Escape') {
            this.onClose();
        }
    };

    onClose = () => {
        const {
            setParentActiveIndex,
            parentSliderRef,
            index,
            close,
        } = this.props;
        const { index: newStateIndex } = this.state;
        let newIndex = newStateIndex;
        window.addEventListener('scroll', this.debouncedGetPosition, {
            passive: true,
        });
        window.removeEventListener('keydown', this.onKeyPress);
        if (this.GestureManager && this.isMobile()) {
            typeof this.GestureManager.stopListening === 'function'
                && this.GestureManager.stopListening();
            if (typeof this.GestureManager.index === 'number') {
                newIndex = this.GestureManager.index;
            }
            this.setState({ index: newIndex });
        }
        if (index !== newIndex) {
            setParentActiveIndex(newIndex);
            if (this.isMobile()) {
                const newScrollLeft = newIndex * window.innerWidth;
                if (newScrollLeft !== parentSliderRef.scrollLeft) {
                    parentSliderRef.scrollLeft = newIndex * window.innerWidth;
                }
            }
        }
        this.setState({ isOpen: false }, close);
    };

    /**
     * The concept of zoom animation when the ZoomedGallery is openning is based on switching 2
     * state of style attribute (in other word: switching 2 transfrom property values).
     * In order to keep image quality transform scale value is set to 1 when gallery has been
     * already opened, which means scale value is always below 1.
     * On desktop only active slide is being animated.
     * On mobile there is switching styles for slider + for every uniq slide config is distinct.
     */
    getPosition = (e, props = this.props) => {
        const device = this.isMobile() ? 'mobile' : 'desktop';
        const { rootRef, parentSliderRef, slidesAspectRatio } = props;
        if (!rootRef || !parentSliderRef || !slidesAspectRatio[0]) return;
        const {
            left,
            top,
            width: rootWidth,
            height: rootHeight,
            bottom,
        } = rootRef.getBoundingClientRect();
        // Out of viewport visibility
        if (bottom < 0) return;
        const {
            left: _sliderLeft,
            width: sliderWidth,
            height: sliderHeight,
        } = parentSliderRef.getBoundingClientRect();
        const { innerWidth: _innerWidth, innerHeight: _innerHeight } = window;
        const sliderLeft = left === _sliderLeft // case when thumbnails.length === 0 on desktop / 0 on mobile anyway
            ? MARGINS.desktop.horizontal(_innerWidth)
            : _sliderLeft;
        const innerWidth = _innerWidth
            - sliderLeft
            - (!this.isMobile()
                ? MARGINS.desktop.horizontal(_innerWidth)
                : 2 * MARGINS.mobile.horizontal);
        const innerHeight = _innerHeight - MARGINS[device].top - MARGINS[device].bottom;
        const newRootLeft = this.isMobile() ? 0 : left;
        const sliderTop = Math.max(top, 40);
        const screenAR = innerWidth / innerHeight;
        const sliderAR = sliderWidth / sliderHeight;
        let isPositionSet = true;
        if (!this.isMobile()) {
            this.galleryRootPosition = {
                left: newRootLeft,
                top: sliderTop,
            };
            slidesAspectRatio.forEach(({ imageAR }, idx) => {
                if (!imageAR || isNaN(imageAR)) {
                    isPositionSet = false;
                    return;
                }
                const {
                    height: zoomedImgHeight,
                    width: zoomedImgWidth,
                } = getInnerBoxSize(imageAR, screenAR, {
                    width: innerWidth,
                    height: innerHeight,
                });
                const {
                    height: initialImgHeight,
                    width: initialImgWidth,
                } = getInnerBoxSize(imageAR, sliderAR, {
                    width: sliderWidth,
                    height: sliderHeight,
                });
                const scaleValue = initialImgHeight / zoomedImgHeight;
                const zoomedTransitionX = (innerWidth - zoomedImgWidth) / 2 + sliderLeft;
                const zoomedTransitionY = Math.max(
                    (_innerHeight - zoomedImgHeight) / 2,
                    MARGINS.desktop.top,
                );
                const sizeValues = {
                    width: zoomedImgWidth,
                    height: zoomedImgHeight,
                };
                this.slidesZoomedPosition[idx] = {
                    ...sizeValues,
                    transform: `translate3d(${zoomedTransitionX}px, ${zoomedTransitionY}px, 0)`,
                };
                const scaleErrorTop = (zoomedImgHeight - initialImgHeight) / 2;
                const topWithinSlider = (sliderHeight - initialImgHeight) / 2;
                const transitionY = (top + topWithinSlider - scaleErrorTop) / scaleValue;
                const scaleErrorLeft = (zoomedImgWidth - initialImgWidth) / 2;
                const leftWithinSlider = (sliderWidth - initialImgWidth) / 2;
                const transitionX = (sliderLeft + leftWithinSlider - scaleErrorLeft)
                    / scaleValue;
                this.slidesPosition[idx] = {
                    ...sizeValues,
                    transform: `scale(${scaleValue}) translate3d(${transitionX}px, ${transitionY}px, 0)`,
                };
            });
        }
        if (this.isMobile()) {
            this.galleryRootPosition = {
                left: 0,
                top: 0,
            };
            const mobileSliderHeight = 259;
            const mobileSliderWidth = sliderWidth - (_innerWidth / 2 - 120) * 2;
            const mobileSliderAR = mobileSliderWidth / mobileSliderHeight;
            slidesAspectRatio.forEach(({ imageAR }, idx) => {
                if (!imageAR || isNaN(imageAR)) {
                    isPositionSet = false;
                    return;
                }
                const {
                    height: zoomedImgHeight,
                    width: zoomedImgWidth,
                } = getInnerBoxSize(imageAR, screenAR, {
                    width: innerWidth,
                    height: innerHeight,
                });
                const { height: imgHeight, width: imgWidth } = getInnerBoxSize(
                    imageAR,
                    mobileSliderAR,
                    { width: mobileSliderWidth, height: mobileSliderHeight },
                );
                const scaleValue = imgWidth / zoomedImgWidth;
                const scaleErrorTop = (_innerHeight - _innerHeight * scaleValue) / 2;
                const boxErrorTop = (_innerHeight * scaleValue - mobileSliderHeight) / 2;
                const translationY = (top - boxErrorTop - scaleErrorTop) / scaleValue;
                const sharedStyles = {
                    position: 'fixed',
                    height: _innerHeight,
                    width: _innerWidth,
                };
                this.sliderPosition[idx] = {
                    ...sharedStyles,
                    transform: `scale(${scaleValue}) translate3d(0, ${translationY}px, 0)`,
                };
                this.sliderZoomedPosition[idx] = {
                    ...sharedStyles,
                    transform: 'translate3d(0, 0, 0)',
                };
                const imageMarginX = Math.floor(
                    (_innerWidth - zoomedImgWidth) / 2,
                );
                const imageMarginY = Math.floor(
                    (_innerHeight - zoomedImgHeight) / 2,
                );
                const sharedSizeValues = {
                    width: _innerWidth,
                    height: _innerHeight,
                    padding: `${imageMarginY}px ${imageMarginX}px`,
                };
                this.slidesZoomedPosition[idx] = sharedSizeValues;
                this.slidesPosition[idx] = sharedSizeValues;
            });
        }
        this.setState({ isPositionSet });
    };

    isMobile = (userDevice = this.props.userDevice) => userDevice === 'mobile';

    getSliderWrapStyles = (idx) => {
        if (this.isMobile()) {
            const { isOpen } = this.state;
            return isOpen
                ? this.sliderZoomedPosition[idx]
                : this.sliderPosition[idx];
        }
        return {};
    };

    setActiveIndexOnScroll = (e) => {
        const { isOpen, index } = this.state;
        if (!isOpen) return;
        const newIndex = Math.round(e.target.scrollLeft / window.innerWidth);
        if (index !== newIndex) {
            this.setState({ index: newIndex });
        }
    };

    onImageClick = (e) => {
        e.stopPropagation();
    };

    render() {
        const { isOpen, index } = this.state;
        const {
            imageList,
            isOpen: propsIsOpen,
            slidesAspectRatio,
        } = this.props;
        const sliderStyles = this.isMobile()
            ? {
                width: window.innerWidth * slidesAspectRatio.length,
                transform: `translateX(${-window.innerWidth * index}px)`,
            }
            : {};
        return (
            <Portal>
                <Root visible={propsIsOpen} ref={(el) => (this.root = el)}>
                    <Background
                        onClick={!this.isMobile() ? this.onClose : undefined}
                    />
                    <ImageGallery style={this.galleryRootPosition}>
                        {imageList.length !== 1 && (
                            <ThumbList>
                                {imageList.map((_, idx) => {
                                    const imgSrc = imageList[idx]
                                        && imageList[idx].urls
                                        && imageList[idx].urls.mini_square;
                                    return (
                                        <ThumbWrap
                                            key={idx}
                                            ref={(el) => (this.thumbnails[idx] = el)}
                                            active={index === idx}
                                            onMouseMove={this.setNewIndex(idx)}
                                            onClick={this.setNewIndex(idx)}
                                            className={
                                                this.isMobile()
                                                && idx === index
                                                && 'active'
                                            }
                                        >
                                            <ThumbImg src={imgSrc} />
                                        </ThumbWrap>
                                    );
                                })}
                            </ThumbList>
                        )}
                        <CloseButton onClick={this.onClose}>
                            <CloseIcon />
                        </CloseButton>
                        <SliderWrap style={this.getSliderWrapStyles(index)}>
                            <Slider
                                ref={(el) => (this.slider = el)}
                                style={sliderStyles}
                            >
                                {imageList.map((slide, idx) => (
                                    <SlideImage
                                        key={idx}
                                        ref={(el) => (this.slides[idx] = el)}
                                        style={
                                            isOpen
                                                ? this.slidesZoomedPosition[idx]
                                                : this.slidesPosition[idx]
                                        }
                                        {...(slidesAspectRatio[idx]
                                            ? slidesAspectRatio[idx]
                                            : {})}
                                        onClick={
                                            !this.isMobile()
                                                ? this.onImageClick
                                                : undefined
                                        }
                                        active={index === idx}
                                        alt={slide.alt}
                                    />
                                ))}
                            </Slider>
                        </SliderWrap>
                    </ImageGallery>
                </Root>
            </Portal>
        );
    }
}

ZoomedGallery.propTypes = {
    rootRef: PropTypes.shape({}),
    sliderRef: PropTypes.shape({}),
    parentSliderRef: PropTypes.shape({}),
    close: PropTypes.func.isRequired,
    setParentActiveIndex: PropTypes.func.isRequired,
    userDevice: PropTypes.string,
    index: PropTypes.number.isRequired,
    isOpen: PropTypes.bool.isRequired,
    imageList: PropTypes.arrayOf(PropTypes.object).isRequired,
    slidesAspectRatio: PropTypes.arrayOf(
        PropTypes.shape({
            src: PropTypes.string,
            srcset: PropTypes.string,
            sizes: PropTypes.string,
        }),
    ),
};

ZoomedGallery.defaultProps = {
    slidesAspectRatio: [],
    userDevice: undefined,
    rootRef: undefined,
    sliderRef: undefined,
    parentSliderRef: undefined,
};
